if (!customElements.get('hero-mondo-slideshow')) {
  class HeroMondoSlideshow extends HTMLElement {
    connectedCallback() {
      // Defer init until children are parsed into the DOM
      setTimeout(() => this._init(), 0);
    }

    _init() {
      this.slides = Array.from(this.querySelectorAll('.hero-mondo__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-mondo__dot'));
      this.current = 0;
      this.touchStartX = 0;

      // Content panels live outside this element — find them via the section root
      const section = this.closest('.hero-mondo');
      this.contentPanels = section
        ? Array.from(section.querySelectorAll('[data-slide-content]'))
            .sort((a, b) => parseInt(a.dataset.slideContent, 10) - parseInt(b.dataset.slideContent, 10))
        : [];

      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => this.goTo(i))
      );

      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].screenX - this.touchStartX;
        if (Math.abs(delta) > 50) delta < 0 ? this.next() : this.prev();
      }, { passive: true });

      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    goTo(index) {
      if (index === this.current) return;

      // Outgoing
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) {
        this.dots[this.current].classList.remove('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'false');
      }
      if (this.contentPanels[this.current]) {
        this.contentPanels[this.current].classList.remove('is-active');
      }

      // Advance index
      this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;

      // Incoming
      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'true');
      }
      if (this.contentPanels[this.current]) {
        this.contentPanels[this.current].classList.add('is-active');
      }
    }

    next() { this.goTo(this.current + 1); }
    prev() { this.goTo(this.current - 1); }

    startAutoplay() {
      this.stopAutoplay();
      const speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
      this.autoplayTimer = setInterval(() => this.next(), speed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
    }
  }

  customElements.define('hero-mondo-slideshow', HeroMondoSlideshow);
}
